import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { AuthorisationClinicianAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-authorisation-clinician-slot',
    templateUrl: './authorisation-clinician-slot.component.html',
    styleUrl: './authorisation-clinician-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthorisationClinicianSlotComponent implements SheetSlotComponentBase {

	@Input() action!: AuthorisationClinicianAction;
	value = null;

	constructor() {
	}
}